import styled from "styled-components";





export const Theme = styled.div`


text-align: center;
margin-bottom: 30px;


label{
  display: block;
  margin-bottom: 10px;

}

span{
  margin-top: 10px;
  img{
  width: 30px;
  margin: -10px 15px;
}
}

input{
  width: 30px;
  cursor: pointer;

}





`




export const FooterStyled = styled.footer`

padding-top: 100px;
  margin-top: 120px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;



`




export const Description = styled.div`


 text-align: center;
  width: 80%;
  margin-bottom: 70px;


 h2 {
  color: ${props => props.theme.siteColor};
  margin-bottom: 20px;
  font-size: 60px;
}

p {
  font-size: 18px;
}


@media screen and (max-width: 400px) {
 
  h2{
    font-size: 45px;
  }

}


`


export const Icons = styled.div`

  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 40px;


 button {
  width: 300px;
  margin-bottom: 40px;
  padding: 10px;
  background-color: ${props => props.theme.backgroundColorNavFooter};
  color: ${props => props.theme.linksColor};
  cursor: pointer;
  transition: all 0.4s;
  border: none;
}

 button:hover {
  transform: scale(1.1);
}

 button::before {
  content: "";
  display: inline-block;
  background-size: cover;
  width: 30px;
  height: 30px;
  margin-bottom: -10px;
  margin-right: 10px;
}

`


export const End = styled.div`

 text-align: center;
  padding: 30px;
  background-color: ${props => props.theme.backgroundColorNavFooter};
  width: 100%;
  position: relative;


 

  button {
  background-color: ${props => props.theme.backgroundColorNavFooter};
  border: none;
  color: ${props => props.theme.linksColor};
  cursor: pointer;
  position: relative;
  width: 150px;
  height: 80px;
  


  span::before {
  position: absolute;
  content: "";
  display: inline-block;
  background-size: cover;
  width: 30px;
  height: 40px;
  top: 50%;
  background: url(${props => props.theme.arrowFooter}) center no-repeat;
  background-size: cover;
  animation: seta 0.5s infinite alternate linear;
  left: 0%;
  transform: translate(-10%, -50%);
}


}



@keyframes seta {
  0% {
    top: 45%;
  }

  100% {
    top: 30%;
  }
}


`


export const SocialMedia = styled.a`
button::before{
  background: url(${props => props.path}) center no-repeat;
}

`